// extracted by mini-css-extract-plugin
export default {"videoPlayer":"VideoPlayer_videoPlayer__3cVVr","landscape":"VideoPlayer_landscape__vFUcJ"};